import { GeneralApiService } from '@api_patient/general_api.service';
import { AuthService } from '@application/authentication/auth.service';
import { I18nAndL10n } from '@application/i18n/mod';
import { UserSettingsService } from '@feature/settings/user_settings.service';
import { ControllerProtocol, Injectable, Scopes } from '@visiba/instantiation';

@Injectable({
	scope: Scopes.Scoped,
})
export class LanguageSelectController implements ControllerProtocol {
	constructor(
		private readonly authService: AuthService,
		private readonly userSettingsService: UserSettingsService,
		private readonly generalApiService: GeneralApiService,
	) {}

	// biome-ignore lint/suspicious/noEmptyBlockStatements: suppressed due to migration - should be fixed
	public whenMount() {}
	public setLanguage(languageCode: string) {
		I18nAndL10n.updateLangCode(languageCode);

		localStorage.setItem('languageCode', languageCode);
		this.userSettingsService.updateSettings({
			selectedLanguage: I18nAndL10n.convertExternalLocaleToAvailableLocale(languageCode),
		});
		if (this.authService.isSignedIn()) {
			this.generalApiService.setlanguage(languageCode).then(() => {
				window.location.reload();
			});
		} else {
			window.location.reload();
		}
	}
}
